import React, { lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

// project imports
import GuestGuard from './../utils/route-guard/GuestGuard';
import MinimalLayout from './../layout/MinimalLayout';
import NavMotion from './../layout/NavMotion';
import Loadable from '../ui-component/Loadable';

// login routing
const AuthLogin = Loadable(lazy(() => import('../views/pages/authentication/login')));
const AuthRegister = Loadable(lazy(() => import('../views/pages/authentication/register')));
const AuthForgotPassword = Loadable(lazy(() => import('../views/pages/authentication/forgot-password')));
const AuthUpdatePassword = Loadable(lazy(() => import('../views/pages/authentication/update-password')));
const AuthVerifyMail = Loadable(lazy(() => import('../views/pages/authentication/verify-mail')));
const AuthVerifySuccess = Loadable(lazy(() => import('../views/pages/authentication/verify-success')));

//-----------------------|| AUTH ROUTING ||-----------------------//

const LoginRoutes = () => {
    const location = useLocation();

    return (
        <Route path={['/login', '/register' , '/forgot-password', '/reset-password','/verify-mail', '/verify-success' ]}>
            <MinimalLayout>
                <Switch location={location} key={location.pathname}>
                    <NavMotion>
                        <GuestGuard>
                            <Route path="/login" component={AuthLogin} />
                            <Route path="/register" component={AuthRegister} />
                            <Route path="/forgot-password" component={AuthForgotPassword} />
                            <Route path="/reset-password" component={AuthUpdatePassword} />
                            <Route path="/verify-mail" component={AuthVerifyMail} />
                            <Route path="/verify-success" component={AuthVerifySuccess} />
                        </GuestGuard>
                    </NavMotion>
                </Switch>
            </MinimalLayout>
        </Route>
    );
};

export default LoginRoutes;
